import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { Nav } from "@/components/shell/Nav";
import { TopBar } from "@/components/shell/TopBar";
import { ChatSidebar } from "@/features/chat/ChatSidebar";
import { Onboarding, shouldShowOnboarding } from "@/features/onboarding/Onboarding";

export function Shell() {
  const [chatOpen, setChatOpen] = useState(false);
  const [tourOpen, setTourOpen] = useState(false);

  // Global ⌘K / Ctrl+K toggles the Flow chat sidebar.
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") {
        e.preventDefault();
        setChatOpen((o) => !o);
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  // First-visit tour. Defer by one frame so the dashboard lays out first,
  // which lets the highlight ring measure the real dashboard-grid rect.
  useEffect(() => {
    if (!shouldShowOnboarding()) return;
    const id = window.requestAnimationFrame(() => setTourOpen(true));
    return () => window.cancelAnimationFrame(id);
  }, []);

  return (
    <div className="flex h-screen bg-paper-1 text-ink-1">
      <Nav />
      <div className="flex flex-1 flex-col overflow-hidden">
        <TopBar
          onOpenChat={() => setChatOpen(true)}
          onReplayTour={() => setTourOpen(true)}
        />
        <main className="min-h-0 flex-1 overflow-hidden">
          <Outlet />
        </main>
      </div>
      <ChatSidebar open={chatOpen} onClose={() => setChatOpen(false)} />
      {tourOpen && <Onboarding onClose={() => setTourOpen(false)} />}
    </div>
  );
}
